import * as Sentry from '@sentry/react';

const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;

export function initSentry() {
    if (!dsn) return;

    Sentry.init({
        dsn,
        release: process.env.NEXT_PUBLIC_GIT_SHA || undefined,
        environment: process.env.NEXT_PUBLIC_APP_ENV || 'production',
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        tracesSampleRate: 0.1,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1.0,
    });
}
